import { render } from "./SeekbarComponent.vue?vue&type=template&id=ec8c984c&ts=true"
import script from "./SeekbarComponent.vue?vue&type=script&lang=ts"
export * from "./SeekbarComponent.vue?vue&type=script&lang=ts"

import exportComponent from "D:\\a\\1\\s\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__